"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ResultScore {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
        else {
            this.resultScore = 81;
            this.comment = "Instructor comment on the student performance";
            this.studentName = "Completed";
            this.id = "FullyGraded";
            this.studentId = "etaffins";
            this.resultMaximum = 100;
        }
    }
}
exports.default = ResultScore;
